import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';

/** Job de geração de PDF do relatório por seleção de prestadores — controla polling e download via sessionStorage. */
@Injectable({ providedIn: 'root' })
export class RelatorioSelecaoPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'relatorio-selecao-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.relatorioSelecaoPj;
}
